import * as React from "react";
import Ifix1 from "../Images/ifix1.png";

function Hero() {
  return (
    <div className="flex overflow-hidden relative flex-col justify-center items-center px-16 py-20 text-white leading-[100.9%] min-h-[636px] max-md:px-5">
      <img
        loading="lazy"
        src={Ifix1}
        className="object-cover absolute inset-0 size-full"
      />
      <div className="flex relative flex-col max-w-full w-[743px] max-md:mt-10">
        <div className="text-7xl font-bold text-center max-md:max-w-full max-md:text-4xl">
          Residential Solar{" "}
        </div>
        <div className="justify-center self-center px-5 py-3.5 mt-16 text-sm font-medium bg-cyan-700 max-md:pl-5 max-md:mt-10">
          View Recipes
        </div>
      </div>
    </div>
  );
}

export default Hero;
